module.exports = __webpack_public_path__ + "static/media/image_case_kaoqin.e78a9313.png";